// Pure booking-URL construction.
//
// The booking engine takes a duration plus a start-date *window*
// (earliest..latest start), not a fixed departure/return pair:
//   - "month" mode: the window spans the chosen month and the duration is the
//     explicit nights the user picked.
//   - "dates" mode: nights is the gap between the picked days; the window is
//     the chosen day, optionally widened by the +/- fuzzy flexibility. The
//     earliest start can never fall before `earliestAllowedStart` (tomorrow).

import { format, differenceInDays, addDays, subDays, max } from "date-fns";

// Returns { nights, earliestStart, latestStart } with dates as yyyy-MM-dd
// strings. `earliestAllowedStart` is the floor for the earliest start (pass
// startOfTomorrow()); kept as a parameter so this stays pure and testable.
export const computeStartWindow = ({
    dateMode,
    selectedFromDate,
    selectedToDate,
    selectedDuration,
    flexDays,
    earliestAllowedStart,
}) => {
    let nights, earliestStartDate, latestStartDate;
    if (dateMode == "month") {
        nights = selectedDuration;
        earliestStartDate = selectedFromDate;
        latestStartDate = selectedToDate;
    } else {
        nights = differenceInDays(selectedToDate, selectedFromDate);
        earliestStartDate = max([subDays(selectedFromDate, flexDays), earliestAllowedStart]);
        latestStartDate = addDays(selectedFromDate, flexDays);
    }
    return {
        nights,
        earliestStart: format(earliestStartDate, "yyyy-MM-dd"),
        latestStart: format(latestStartDate, "yyyy-MM-dd"),
    };
};

// Builds the full booking-engine URL. Packages ("/P/") carry departure
// airports; accommodation-only stays ("/AO/") do not.
export const buildBookingUrl = ({
    bookingEngineBaseUrl,
    searchType,
    departures,
    destinationCodes,
    nights,
    earliestStart,
    latestStart,
    roomsString,
}) => {
    if (searchType == "stays") {
        return `${bookingEngineBaseUrl}/AO/${destinationCodes}/${nights}/${earliestStart}/${latestStart}/${roomsString}`;
    }
    return `${bookingEngineBaseUrl}/P/${departures.join('-')}/${destinationCodes}/${nights}/${earliestStart}/${latestStart}/${roomsString}`;
};
